import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#skeleton" }),
    /*#__PURE__*/_createTextVNode(" Skeleton ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, [
    /*#__PURE__*/_createTextVNode(" When loading data, and you need a rich experience for visual and interactions for your end users, you can choose "),
    /*#__PURE__*/_createVNode("code", null, "skeleton"),
    /*#__PURE__*/_createTextVNode(". ")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicUsage = _resolveComponent("EUIBasicUsage")
  const _component_EUIConfigurableRows = _resolveComponent("EUIConfigurableRows")
  const _component_EUIAnimation = _resolveComponent("EUIAnimation")
  const _component_EUICustomizedTemplate = _resolveComponent("EUICustomizedTemplate")
  const _component_EUILoadingState = _resolveComponent("EUILoadingState")
  const _component_EUIRenderingAListOfData = _resolveComponent("EUIRenderingAListOfData")
  const _component_EUIAvoidingRenderingBouncing = _resolveComponent("EUIAvoidingRenderingBouncing")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicUsage),
    _createVNode(_component_EUIConfigurableRows),
    _createVNode(_component_EUIAnimation),
    _createVNode(_component_EUICustomizedTemplate),
    _createVNode(_component_EUILoadingState),
    _createVNode(_component_EUIRenderingAListOfData),
    _createVNode(_component_EUIAvoidingRenderingBouncing)
  ], 64))
}